module.exports = __webpack_public_path__ + "img/more.1950d604.svg";